import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";

export const getDiseaseByClinicId = createAsyncThunk('/getDiseaseByClinicId', async (data, { rejectWithValue }) => {

    try {
        const response = await axios.get(`${ENDPOINTS.CLINIC.DISEASE}?clinicInfoId=${data.selectedClinicId}`)
        return response.data;
    } catch (error) {
        return rejectWithValue(
            error.response?.data ||
            "Something went wrong while fetching the buyer profile."
        );
    }
})

const initialState = {
    data: [],
    isLoading: true,
    error: null,
};

const getDiseaseByClinicIdSlice = createSlice(
    {
        name: "disease",
        initialState,
        extraReducers: (builder) => {
            builder.addCase(getDiseaseByClinicId.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.isLoading = false;
                state.error = null;
            })
                .addCase(getDiseaseByClinicId.pending, (state) => {
                    state.isLoading = true;
                    state.error = null;
                })
                .addCase(getDiseaseByClinicId.rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload;
                })
        }
    }
)

export default getDiseaseByClinicIdSlice.reducer;